import * as React from 'react';

import { Icon } from '../icon/icon.tsx';

import './button.css';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  leadingIcon?: React.ReactNode;
  trailingIcon?: React.ReactNode;
  size?: 'small' | 'regular' | 'hero';
  variant?: 'primary' | 'secondary' | 'tertiary';
  kind?: 'default' | 'danger' | 'muted';
  asToast?: boolean;
  asRemoveIcon?:
    | 'neutral'
    | 'color'
    | 'danger'
    | 'disabled'
    | 'default'
    | 'signature';
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      size = 'regular',
      variant = 'primary',
      kind = 'default',
      leadingIcon,
      trailingIcon,
      asToast,
      asRemoveIcon,
      children,
      disabled,
      type = 'button',
      className,
      ...props
    },
    ref,
  ) => {
    const onlyIcon = !children && (leadingIcon || trailingIcon);

    return asToast === true ? (
      <button
        type={type}
        className="button-toast"
        disabled={disabled}
        ref={ref}
        {...props}
      >
        {leadingIcon && (
          <div className={'button-toast-icon button-toast-icon-leading'}>
            {leadingIcon}
          </div>
        )}
        {children}
        {trailingIcon && (
          <div className="button-toast-icon button-toast-icon-trailing">
            {trailingIcon}
          </div>
        )}
      </button>
    ) : asRemoveIcon ? (
      <button
        type={type}
        className={`button-remove-icon ${className}`}
        disabled={disabled}
        ref={ref}
        {...props}
      >
        <Icon type="x" className={`button-remove-icon-${asRemoveIcon}`} />
      </button>
    ) : (
      <button
        type={type}
        className={
          disabled
            ? `button button-${size} ${variant}-disabled-button ${
                onlyIcon && 'button-icon-only'
              } ${className ?? ''}`
            : `button button-${size} ${variant}-${kind}-button ${
                onlyIcon && 'button-icon-only'
              } ${className ?? ''}`
        }
        disabled={disabled}
        ref={ref}
        {...props}
      >
        {leadingIcon && (
          <div className="button-icon button-icon-leading">{leadingIcon}</div>
        )}
        {children}
        {trailingIcon && (
          <div className="button-icon button-icon-trailing">{trailingIcon}</div>
        )}
      </button>
    );
  },
);

export { Button };
